import plugin from '../plugin.js'
import VueMDCTextField from './mdc-textfield.vue'

export {VueMDCTextField}

export default plugin({
  VueMDCTextField
})



// WEBPACK FOOTER //
// ./node_modules/vue-mdc-adapter/components/textfield/index.js